import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { AddPermitTypeFormInputs } from '@src/permitTypesManager/AddPermitTypeFormInputs';
import {
  AxleCapacityField,
  AxleGroupField,
  AxleSpacingField,
  AxleTypeField,
  AxleWeightField,
  AxleWidthField,
  IsSteeringAxleField,
  SuspensionField,
  TireCountField,
  TireRatingField,
  TireSizeField,
} from '@src/permitTypesManager/permitTypeSections/AxleTireSuspensionFields';
import type { SectionField } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { PermitTypeSectionCheckboxList } from '@src/permitTypesManager/permitTypeSections/PermitTypeSectionCheboxList';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const AxleTireSuspensionSection = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AddPermitTypeFormInputs>();
  const fields: SectionField[] = [
    {
      field: AxleSpacingField,
      label: t('fields.axleSpacing'),
    },
    {
      field: AxleWeightField,
      label: t('fields.axleWeight'),
    },
    {
      field: AxleWidthField,
      label: t('fields.axleWidth'),
    },
    {
      field: AxleCapacityField,
      label: t('fields.axleCapacity'),
    },
    {
      field: TireCountField,
      label: t('fields.tireCount'),
    },
    {
      field: TireRatingField,
      label: t('fields.tireRating'),
    },
    {
      field: TireSizeField,
      label: t('fields.tireSize'),
    },
    {
      field: SuspensionField,
      label: t('fields.suspensionType'),
    },
    {
      field: IsSteeringAxleField,
      label: t('fields.isSteeringAxle'),
    },
    {
      field: AxleGroupField,
      label: t('fields.axleGroup'),
    },
    {
      field: AxleTypeField,
      label: t('fields.axleType'),
    },
  ];
  return (
    <Stack direction="column" gap={theme.spacing['1']}>
      <PermitTypeSectionCheckboxList sectionFields={fields} control={control} />
    </Stack>
  );
};
